<template>
  <div>
    <div
      style="border: 1px grey solid; background-color: whitesmoke; overflow: auto; height: 65vh"
      class="pa-3"
    >
      <div style="font-size: 14px">
        <div class="font-weight-bold" style="text-indent: 20px">
          การแจ้งความประสงค์ขอรับเงินผลประโยชน์ตามกรมธรรม์ผ่านบัญชีธนาคาร หรือ ผ่านบัญชีพร้อมเพย์
          (Prompt pay) โดยใช้เลขที่บัตรประชาชน
        </div>
        <div style="text-indent: 20px" class="mb-2">
          ข้าพเจ้าในฐานะผู้เอาประกันภัย หรือผู้แทนโดยชอบธรรม
          (ของผู้เยาว์/ผู้ไร้ความสามารถ/ผู้เสมือนไร้ความสามารถ) หรือเจ้าของกรมธรรม์
          (ผู้รับโอนสิทธิผลประโยชน์แห่งกรมธรรม์ประกันภัย) ขอให้บริษัท เจนเนอราลี่ ประกันชีวิต
          (ไทยแลนด์) จำกัด (มหาชน) และ/หรือ บริษัท เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน)
          (“บริษัท”) นำจ่ายเงินผลประโยชน์ตามกรมธรรม์
          หรือเงินเกินจากการชำระเบี้ยประกันหรือจากการชำระเงินกู้ยืมเงินตามกรมธรรม์
          หรือเงินเวนคืนกรมธรรม์/ส่วนต่างมูลค่าเวนคืน เงินค่าสินไหม หรือเงินจ่ายคืนอื่นๆของข้าพเจ้า
          ซึ่งเงินดังกล่าวเกิดขึ้นตั้งแต่วันที่บริษัทอนุมัติการแจ้งความประสงค์นี้
          ให้โอนเข้าบัญชีธนาคาร หรือ บัญชีพร้อมเพย์ (Prompt pay) โดยใช้เลขที่บัตรประชาชน
          ของข้าพเจ้าที่ให้ไว้กับบริษัท
        </div>

        <div style="text-decoration: underline">ข้อกำหนดและเงื่อนไข</div>
        <ul style="list-style-type: decimal" class="mb-2">
          <li>
            ชื่อเจ้าของบัญชีธนาคาร หรือ บัญชีพร้อมเพย์ (Prompt pay) โดยใช้เลขที่บัตรประชาชน
            ต้องเป็นชื่อเดียวกับชื่อผู้เอาประกันภัย หรือผู้แทนโดยชอบธรรม
            (ของผู้เยาว์/ผู้ไร้ความสามารถ/ผู้เสมือนไร้ความสามารถ) หรือเจ้าของกรมธรรม์
            (ผู้รับโอนสิทธิผลประโยชน์แห่งกรมธรรม์ประกันภัย)
          </li>
          <li>การเปลี่ยนแปลงจะมีผลบังคับในงวดถัดไปหลังจากที่บริษัทได้รับเอกสารครบถ้วน</li>
          <li>
            กรณีที่บริษัทไม่สามารถนำเงินผลประโยชน์หรือเงินคืนเข้าบัญชีของข้าพเจ้าตามที่แจ้งความประสงค์นี้
            ไม่ว่าด้วยสาเหตุใดก็ตาม ข้าพเจ้ายินดีรับเงินดังกล่าวเป็นเช็ค
            หรือดราฟท์ตามวิธีการปกติของบริษัท
            และไม่ถือเป็นการจ่ายผลประโยชน์หรือคืนเงินล่าช้าตามข้อกำหนดของกรมธรรม์
          </li>
          <li>
            หากมีการเปลี่ยนแปลงใดๆ
            ที่เกี่ยวกับบัญชีธนาคารหรือวิธีการรับเงินผลประโยชน์ตามกรมธรรม์ของข้าพเจ้า
            ข้าพเจ้าจะดำเนินการแจ้งแก่บริษัททราบเป็นลายลักษณ์อักษรล่วงหน้าอย่างน้อย 1
            เดือนก่อนวันครบรอบปีกรมธรรม์หรือวันครบกำหนดการจ่ายเงินตามกรมธรรม์
          </li>
        </ul>
        <div style="text-indent: 20px" class="mb-2">
          ข้าพเจ้ายินยอมให้บริษัท เจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน)
          และ/หรือธนาคารตามบัญชีเงินฝากของข้าพเจ้าดำเนินการตรวจสอบความถูกต้อง และ/หรือเก็บ ใช้
          และเปิดเผยข้อมูลอ่อนไหวที่ได้รับจากสำเนาบัตรประชาชนหรือหนังสือเดินทางของข้าพเจ้า
          และข้อมูลเลขที่บัญชีและชื่อบัญชีของข้าพเจ้าที่มอบแก่บริษัทเพื่อประโยชน์ในการยืนยันตัวตนของข้าพเจ้าและยินยอมให้บริษัททำการบันทึกหรือปรับปรุงข้อมูลเบอร์ติดต่อและอีเมลของข้าพเจ้าเพื่อใช้ในการติดต่อสื่อสารต่อไป
        </div>
        <div style="text-indent: 20px">
          ติดต่อสอบถามเพิ่มเติม กรุณาติดต่อศูนย์ลูกค้าสัมพันธ์ โทร 1394 ภายในวันและเวลาทำการ
          วันจันทร์ - วันศุกร์ เวลา 8.30-20.00 น. และวันเสาร์ เวลา 8.30-17.00 น. LINE:
          <a
            href="https://line.me/ti/p/@generalithailand"
            target="_blank"
            rel="noopener noreferrer"
          >
            @generalithailand
          </a>
          หรือ Email:
          <a href="mailto:info@generali.co.th">info@generali.co.th</a>
          ประสงค์รับเงินผ่านบัญชีธนาคารและให้ความยินยอมเกี่ยวกับการเก็บ ใช้
          และเปิดเผยข้อมูลตามข้างต้น
        </div>
      </div>
    </div>
    <div>
      <v-checkbox v-model="cb" color="primary">
        <template v-slot:label>
          <div style="color: black; font-size: 16px">
            ประสงค์รับเงินผ่านบัญชีธนาคาร หรือบัญชีพร้อมเพย์ (Prompt pay) โดยใช้เลขที่บัตรประชาชน
            และให้ความยินยอมเกี่ยวกับการเก็บ ใช้ และเปิดเผยข้อมูลตามข้างต้น
          </div>
        </template>
      </v-checkbox>
    </div>
    <div class="text-center">
      <v-btn @click="next" :disabled="!cb" class="px-10" color="primary" small depressed>
        <span style="font-size: 18px">ยืนยัน</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  data() {
    return {
      cb: false,
    };
  },
  methods: {
    next() {
      this.$store.state.step++;
    },
  },
};
</script>

<style lang="scss" scoped></style>
